import toast from "react-hot-toast";
import useApi from "../useApi";
import { IPatient } from "./index.type";

interface IUpdatePhoneCallReminderReq {
  phoneCallReminderDate: string;
}

interface IUpdatePhoneCallReminderRes {
  status: string;
  message: string;
  data?: IPatient;
}

const useUpdatePhoneCallReminderDate = () => {
  const { loading, makeApiCall } = useApi({
    url: "",
    method: "PATCH",
  });

  const updatePhoneCallReminderDate = async (
    patientId: string,
    data: IUpdatePhoneCallReminderReq,
  ): Promise<IUpdatePhoneCallReminderRes | undefined> => {
    const { response, error } = await makeApiCall<
      IUpdatePhoneCallReminderReq,
      IUpdatePhoneCallReminderRes
    >(
      data,
      `/rtm/billing-cycle/phone-call-reminder-date?patientId=${patientId}`,
    );

    if (response?.status === "success") {
      toast.success(response.message);
      return response;
    }

    if (error) {
      toast.error(error.msg);
    }
  };

  return {
    updatePhoneCallReminderDate,
    loading,
  };
};

export default useUpdatePhoneCallReminderDate;
